// Фільтри заявок. Статуси звірені з тим, що реально ставить сервер,
// джерело додано: заявки з опитування на головній помітно відрізняються
// від звичайної форми зворотного звʼязку.
export const LEAD_REQUESTS_FILTERS = [
  {
    key: 'formType',
    type: 'checkbox',
    label: 'Тип форми',
    options: [
      { value: 'contact', label: 'Звичайна форма' },
      { value: 'development_plan', label: 'План розвитку' },
    ],
  },
  {
    key: 'source',
    type: 'checkbox',
    label: 'Звідки заявка',
    options: [
      { value: 'website', label: 'Форма на сайті' },
      { value: 'website-assessment', label: 'Опитування на головній' },
    ],
  },
  {
    key: 'status',
    type: 'checkbox',
    label: 'Статус',
    options: [
      { value: 'received', label: 'Нова' },
      { value: 'contacted', label: 'Звʼязалися' },
      { value: 'closed', label: 'Закрита' },
    ],
  },
];

export const useLeadRequestsFilters = () => LEAD_REQUESTS_FILTERS;
